import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import {
    Button,
    FormField,
    FormHelp,
    Input,
    Label,
    Textarea,
} from '@zillow/constellation';

import {
    Col,
    DropzoneContainer,
    Row,
} from '@zillow/zrs-comet';

// constants
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';
import NotificationConstants from 'app/shared/constants/NotificationConstants';

import photoUtils from 'app/shared/utils/photoUtils';

import appLogger from 'app/shared/loggers/appLogger';

import InvalidFiletypeText from 'app/shared/components/postingPath/InvalidFiletypeText';

import PostingActions from 'app/shared/actions/PostingActions';
import PaidMFDisabledFieldMessage from 'app/shared/components/postingPath/PaidMFDisabledFieldMessage';
import ListingHeader from 'app/shared/components/postingPath/ListingHeader';
import ListingStats from 'app/shared/components/postingPath/ListingStats';

import {
    StyledAppointmentDiv,
    StyledBtnContainerDiv,
    StyledContactHoursDiv,
    StyledDayLabelText,
    StyledDropzoneContainerDiv,
    StyledIconPlus,
    StyledPropertyLogoDiv,
    StyledUploadedLogoDiv,
    StyledSpinner,
} from './StyledComponents';

import { StyledAnchor } from '../UtilsStyledComponents';

class ListingDetailsMF extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uploadingImages: false,
            showInvalidFiletypeText: false,
            formData: this.props.formData,
        };

        this.updateFormData = this.updateFormData.bind(this);
        this.updateLogo = this.updateLogo.bind(this);
        this.onDropRejected = this.onDropRejected.bind(this);
        this.updateContactTime = this.updateContactTime.bind(this);
        this.removeLogo = this.removeLogo.bind(this);
    }

    updateFormData(event) {
        const value = event.target.value;
        const propName = event.target.name;

        const { formData } = { ...this.state };
        const currentState = formData;
        currentState[propName] = value;
        this.setState({ formData: currentState });
    }

    handleOnBlur = (event) => {
        const { target: { name: propName, value } } = event;
        const { savePropertyData, updateFormData } = this.props;

        savePropertyData(
            propName,
            value,
            {
                componentGroupName: AnalyticsConstants
                    .LISTING_COMPONENT_GROUP_NAME
                    .BUILDING_DETAILS,
            }
        );
        updateFormData({ [propName]: value });
    }

    updateLogo(file) {
        this.setState({
            uploadingImages: true,
            showInvalidFiletypeText: false,
        });

        const formData = new FormData();

        if (Array.isArray(file)) {
            file = file[0];
            appLogger.logInfo({
                message: 'ERROR: Only one image can be uploaded for property logo.',
                context: 'ListingDetailsMF.updateLogo',
            });
        }

        const isValidFiletype = photoUtils.hasValidExtension(file);

        if (!isValidFiletype) {
            this.setState({
                uploadingImages: false,
                showInvalidFiletypeText: true,
            });

            this.props.updateStatusMessage('Saving...');
            this.props.updateStatusMessage(
                ErrorMessageConstants.DEFAULT_PHOTO_ERROR,
                NotificationConstants.ERROR
            );
            return;
        }

        formData.append('sourceFile', file);
        const dataForApi = {
            file,
            formData,
            propertyId: this.props.propertyId,
        };

        this.props.updateStatusMessage('Saving...');
        this.props.updateErrorObj({ logo: null });

        this.props.dispatch(PostingActions.property.uploadLogo(dataForApi))
            .then(() => {
                this.props.updateFormData({
                    logo: file,
                });

                this.props.updateStatusMessage('All data saved!', NotificationConstants.SUCCESS);
                this.setState({ uploadingImages: false });
            })
            .catch((err) => {
                this.setState({ uploadingImages: false });
                this.props.updateStatusMessage(
                    'There was an error with your logo upload. Please check for errors and try again.',
                    NotificationConstants.ERROR
                );
                this.props.updateErrorObj({ logo: err });
            });
    }

    onDropRejected() {
        this.props.updateErrorObj({ logo: 'Please upload a valid image less than 7.5MB in size.' });
    }

    updateContactTime(event) {
        // this.props.updateFormData({
        //     contactHours: assign({}, this.props.formData.contactHours, contactObj),
        // });
        const value = event.target.value;
        const propName = event.target.name;
        const { formData } = { ...this.state };
        const currentState = formData;
        formData.contactHours[propName] = value;
        this.setState({ formData: currentState });
    }

    removeLogo() {
        this.props.updateFormData({
            logo: {},
        });
        this.props.dispatch(PostingActions.property.removeLogo(this.props.propertyId));
    }

    renderLogoUpload() {
        const { uploadingImages, showInvalidFiletypeText } = this.state;
        const { isInputFormDisabled } = this.props;

        const logo = this.props.formData.logo;
        if (!isEmpty(logo)) {
            return (
                <StyledPropertyLogoDiv>
                    <StyledUploadedLogoDiv>
                        <img alt="logo" src={logo.url ? logo.url : logo.preview} />
                    </StyledUploadedLogoDiv>
                    <StyledBtnContainerDiv>
                        <Button
                            buttonType="caution"
                            onClick={this.removeLogo}
                            disabled={isInputFormDisabled}
                        >
                            Remove Logo
                        </Button>
                    </StyledBtnContainerDiv>
                </StyledPropertyLogoDiv>
            );
        }
        return (
            <div>
                {!isInputFormDisabled &&
                    (
                        <StyledDropzoneContainerDiv>
                            <DropzoneContainer
                                accept="image/*"
                                caption="Property Logo"
                                className="needsclick"
                                isUploading={uploadingImages}
                                isUploadingCaption="Uploading image..."
                                onDrop={file => this.updateLogo(file)}
                                onDropRejected={this.onDropRejected}
                            >
                                {uploadingImages ?
                                    (
                                        <StyledSpinner size="xl" />
                                    ) :
                                    (
                                        <StyledIconPlus size="lg" fontColor="blue400" />
                                    )
                                }
                            </DropzoneContainer>
                        </StyledDropzoneContainerDiv>
                    )}

                {this.props.errorObj.logo &&
                        (
                            <FormHelp error={this.props.errorObj.logo}>{this.props.errorObj.logo}</FormHelp>
                        )
                }

                {
                    showInvalidFiletypeText && <InvalidFiletypeText />
                }
            </div>
        );
    }

    render() {
        const { errorObj, isInputFormDisabled, formData } = this.props;
        const { isPaidMultifamily, hasZillowRentConnectBasePackage } = formData;
        const paidMultifamilyPreventChange = isPaidMultifamily && !this.props.isPostingPathAdmin;
        const appointmentsObject = [
            { label: 'Sunday', name: 'contactSunday' },
            { label: 'Monday', name: 'contactMonday' },
            { label: 'Tuesday', name: 'contactTuesday' },
            { label: 'Wednesday', name: 'contactWednesday' },
            { label: 'Thursday', name: 'contactThursday' },
            { label: 'Friday', name: 'contactFriday' },
            { label: 'Saturday', name: 'contactSaturday' },
        ];

        return (
            <div className="ListingDetailsMF">
                <ListingHeader title="Building details" formData={formData} />

                {this.props.isEnterpriseCustomer && <ListingStats listing={formData} />}

                <StyledAnchor id="details" />

                <Row paddingY="xs">
                    <div ref={this.props.listingTitleRef} />
                    <Col>
                        <FormField>
                            <Label disabled={paidMultifamilyPreventChange || isInputFormDisabled} required={true}>
                                Property name
                            </Label>
                            <Input
                                aria-label="My listing"
                                disabled={paidMultifamilyPreventChange || isInputFormDisabled}
                                error={!!errorObj.listingTitle}
                                placeholder="My listing"
                                name="listingTitle"
                                type="text"
                                value={this.state.formData.listingTitle}
                                onChange={this.updateFormData}
                                onBlur={this.handleOnBlur}
                                onFocus={() => this.props.updateOnFocus('listingTitle',
                                    this.props.formData.listingTitle)}
                                data-test="listing-details-mf-listing-title"
                            />
                            {errorObj.listingTitle && (
                                <FormHelp
                                    error={errorObj.listingTitle}
                                    dangerouslySetInnerHTML={{ __html: errorObj.listingTitle }}
                                />
                            )}
                        </FormField>
                    </Col>

                    {paidMultifamilyPreventChange && (
                        <PaidMFDisabledFieldMessage
                            paddingY="xs"
                            as="div"
                            formData={this.props.formData}
                            section="title"
                        />
                    )}
                </Row>
                <Row paddingY="xs">
                    <Col>
                        <div ref={this.props.descriptionRef} />
                        <FormField>
                            <Label disabled={isInputFormDisabled} required={true}>Property description</Label>
                            <Textarea
                                aria-label="Description"
                                resize="both"
                                error={!!errorObj.description}
                                name="description"
                                placeholder="What is awesome about your place?"
                                value={this.state.formData.description}
                                onChange={this.updateFormData}
                                onBlur={this.handleOnBlur}
                                onFocus={() => this.props.updateOnFocus('description', this.props.formData.description)}
                                disabled={isInputFormDisabled}
                            />
                            {errorObj.description && (
                                <FormHelp
                                    error={errorObj.description}
                                    dangerouslySetInnerHTML={{ __html: errorObj.description }}
                                />
                            )}
                        </FormField>
                    </Col>
                </Row>

                {this.props.isPostingPathAdmin &&
                    (
                        <Row paddingY="xs">
                            <Col>
                                <FormField>
                                    <Label disabled={isInputFormDisabled}>
                                    Lease terms
                                    </Label>
                                    <Input
                                        aria-label="Lease terms"
                                        name="leaseTerms"
                                        type="text"
                                        placeholder="Length of lease"
                                        value={this.state.formData.leaseTerms}
                                        error={!!errorObj.leaseTerms}
                                        onChange={this.updateFormData}
                                        onBlur={this.handleOnBlur}
                                        onFocus={() => {
                                            this.props.updateOnFocus('leaseTerms', this.props.formData.leaseTerms);
                                        }}
                                        data-test="listing-details-mf-lease-terms"
                                        disabled={isInputFormDisabled}
                                    />
                                    {errorObj.leaseTerms && (
                                        <FormHelp
                                            error={errorObj.leaseTerms}
                                            dangerouslySetInnerHTML={{ __html: errorObj.leaseTerms }}
                                        />
                                    )}
                                </FormField>
                            </Col>

                        </Row>
                    )
                }
                <Row paddingY="xs">
                    <Col>
                        <Label>Logo</Label>
                        {this.renderLogoUpload()}
                    </Col>
                </Row>
                {!hasZillowRentConnectBasePackage && (
                    <Row paddingY="xs">
                        <Col>
                            <FormField>
                                <Label disabled={paidMultifamilyPreventChange || isInputFormDisabled}>
                                    Website url
                                </Label>
                                <Input
                                    aria-label="Website address"
                                    disabled={paidMultifamilyPreventChange || isInputFormDisabled}
                                    error={errorObj.website}
                                    name="website"
                                    type="url"
                                    placeholder="Website address"
                                    value={this.state.formData.website}
                                    onChange={this.updateFormData}
                                    onBlur={this.handleOnBlur}
                                    onFocus={() => this.props.updateOnFocus('website', this.props.formData.website)}
                                    data-test="listing-details-mf-website"
                                />
                                {errorObj.website &&
                                <FormHelp error={errorObj.website}>{errorObj.website}</FormHelp>
                                }
                            </FormField>
                        </Col>

                        {paidMultifamilyPreventChange && (
                            <PaidMFDisabledFieldMessage
                                paddingY="xs"
                                as="div"
                                formData={this.props.formData}
                                section="website"
                            />
                        )}
                    </Row>
                )}
                <Row paddingY="xs">
                    <Col>
                        <Label>Business hours</Label>
                        {
                            appointmentsObject.map((day) => {
                                const lowerCaseDay = day.label.toLowerCase();
                                return (
                                    <StyledAppointmentDiv key={day.name}>
                                        <StyledDayLabelText
                                            fontType="bodySmall"
                                        >
                                            {`${day.label}:`}
                                        </StyledDayLabelText>
                                        <StyledContactHoursDiv>
                                            <Input
                                                aria-label="8:00am to 5:00pm"
                                                name={lowerCaseDay}
                                                type="text"
                                                placeholder="8:00am to 5:00pm"
                                                value={this.state.formData.contactHours[lowerCaseDay]}
                                                error={!!errorObj[day.name]}
                                                onChange={this.updateContactTime}
                                                onBlur={e => this.props.savePropertyData(
                                                    `${day.name}`,
                                                    e.target.value,
                                                    {
                                                        componentGroupName: AnalyticsConstants
                                                            .LISTING_COMPONENT_GROUP_NAME
                                                            .BUILDING_DETAILS,
                                                    }
                                                )}
                                                onFocus={() => this.props.updateOnFocus(
                                                    `${day.name}`, this.props.formData.contactHours[lowerCaseDay]
                                                )}
                                                data-test={`listing-details-mf-contact-${lowerCaseDay}`}
                                                disabled={isInputFormDisabled}
                                            />
                                            {errorObj[day.name] && (
                                                <FormHelp
                                                    error={errorObj[day.name]}
                                                    dangerouslySetInnerHTML={{ __html: errorObj[day.name] }}
                                                />
                                            )}
                                        </StyledContactHoursDiv>
                                    </StyledAppointmentDiv>
                                );
                            })
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}

export { ListingDetailsMF };
export default connect()(ListingDetailsMF);
